// import qs from 'qs';
import defaultApi from '@/utils/request';

export default {
  Load(params) {
    return defaultApi({
      method: 'get',
      url: 'view_dr_yms/Load',
      params,
    });
  },
};
